<div class="tooltip left-aligned-tooltip"
     [ngClass]="['tooltip--'+position, 'tooltip--'+theme]"
     [class.tooltip--visible]="visible"
     [style.left]="left + 'px'"
     [style.top]="top + 'px'">
  <div class="tooltip-header">
    <i class="bi bi-info-circle info-icon"></i>
  </div>
  <div class="tooltip-content">
    <app-language-output [hrLabel]="hrLabel" [enLabel]="enLabel"
                         [itLabel]="itLabel" [siLabel]="siLabel"
                         [languages]="languages"/>


  </div>
</div>

